import { render, staticRenderFns } from "./ClientOrderReport.vue?vue&type=template&id=41014cba&scoped=true"
import script from "./ClientOrderReport.vue?vue&type=script&lang=js"
export * from "./ClientOrderReport.vue?vue&type=script&lang=js"
import style0 from "./ClientOrderReport.vue?vue&type=style&index=0&id=41014cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41014cba",
  null
  
)

export default component.exports